import { useEffect, useRef } from 'react'
import { trackCustom } from '../components/tracking/metaPixel'

export const useEngagementTracking = () => {
  // Refs to track which milestones have been fired to prevent duplicates
  const scrollMilestones = useRef<Set<number>>(new Set())
  const timeMilestones = useRef<Set<number>>(new Set())

  useEffect(() => {
    // Scroll Depth Tracking
    const handleScroll = () => {
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight
      const scrollTop = window.scrollY
      const scrollPercentage = (scrollTop / scrollHeight) * 100

      const milestones = [25, 50, 75, 100]

      milestones.forEach((milestone) => {
        if (
          scrollPercentage >= milestone &&
          !scrollMilestones.current.has(milestone)
        ) {
          scrollMilestones.current.add(milestone)
          trackCustom('ScrollDepth', { depth: `${milestone}%` })
        }
      })
    }

    // Time on Page Tracking
    const timeIntervals = [30, 60, 120, 300] // seconds
    const timers: NodeJS.Timeout[] = []

    timeIntervals.forEach((seconds) => {
      const timer = setTimeout(() => {
        if (!timeMilestones.current.has(seconds)) {
          timeMilestones.current.add(seconds)
          trackCustom('TimeOnPage', { tier: `${seconds}s` })
        }
      }, seconds * 1000)
      timers.push(timer)
    })

    // Attach scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true })

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll)
      timers.forEach((timer) => clearTimeout(timer))
    }
  }, [])
}
